import { useEffect } from 'react';
import { useAnalytics } from './tracking-context';

export const useTrackPageView = (breadcrumbs: string) => {
    const { sendAnalytics } = useAnalytics();

    useEffect(() => {
        sendAnalytics(breadcrumbs);
    }, [sendAnalytics, breadcrumbs]);
};
